import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {BASE_CLASS, DEFAULT_PRICE_INDICATOR_CONFIG, PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE} from '../../config.js'

const PanelPriceIndicatorTooltip = ({average, offerTypeId, price, rank}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {OFFER_TYPE_NEW, OFFER_TYPE_SUBSCRIPTION} = config.get('search')
  const isRenting = offerTypeId === OFFER_TYPE_SUBSCRIPTION

  const priceIndicatorConfig = PRICE_INDICATOR_CONFIG_BY_OFFER_TYPE[offerTypeId] || DEFAULT_PRICE_INDICATOR_CONFIG

  const baseClassNames = cx(
    `${BASE_CLASS}-tooltip`,
    rank < 3 && `${BASE_CLASS}-tooltip--rightPosition`,
    rank > 3 && `${BASE_CLASS}-tooltip--leftPosition`
  )

  const arrowClassNames = cx(
    `${BASE_CLASS}-tooltipArrow`,
    `${BASE_CLASS}-tooltipArrow--${priceIndicatorConfig.RANKS[rank].POSITION}Position`
  )

  const hasPrice = Boolean(price)
  const hasAverage = Boolean(average) && !isRenting

  const AVERAGE_LABEL = {
    [OFFER_TYPE_NEW]: i18n.t('COMMON.OFFICIAL_PRICE')
  }

  const averageLabel = AVERAGE_LABEL[offerTypeId] || i18n.t('COMMON.MARKET_PRICE')

  return (
    <div className={baseClassNames}>
      <div className={`${BASE_CLASS}-tooltipContent`}>
        <p className={`${BASE_CLASS}-tooltipText ${BASE_CLASS}-tooltipText--bold`}>
          Es un {priceIndicatorConfig.RANKS[rank].LABEL}
          {hasPrice && `: ${i18n.c(price)}`}
        </p>
        {hasAverage && (
          <p className={`${BASE_CLASS}-tooltipText`}>
            {averageLabel}: {i18n.c(average)}
          </p>
        )}
      </div>
      <div className={arrowClassNames} />
    </div>
  )
}

PanelPriceIndicatorTooltip.displayName = 'PanelPriceIndicatorTooltip'

PanelPriceIndicatorTooltip.propTypes = {
  average: PropTypes.number,
  offerTypeId: PropTypes.number,
  price: PropTypes.number,
  rank: PropTypes.numer
}

export default PanelPriceIndicatorTooltip
